var exports = {
  "P_": "SanitizedHtml__mwJBFY",
  "wG": "OptionTitle__iCyycj",
  "Zb": "SanitizedHtml_1__5EamSY",
  "bH": "ColorDecorator__RiF4z_",
};

module.exports = exports;
